class AuthService {
    login(user) {
        return axios
            .post('auth/login', {
                email: user.email,
                code: user.code,
                password: user.password,
                // platform: 'observe'
            })
            .then(response => {
                // console.log(response.data)
                if (response.data.access_token) {
                    localStorage.setItem('user', JSON.stringify(response.data.user));
                    localStorage.setItem('type', JSON.stringify(response.data.type));
                    localStorage.setItem('accessToken', JSON.stringify(response.data.access_token));
                    // localStorage.setItem('consultant', JSON.stringify(response.data.consultant));
                    // localStorage.setItem('is_alliance_leader', JSON.stringify(response.data.is_alliance_leader));
                    // localStorage.setItem('is_belong_to_alliacne', JSON.stringify(response.data.is_belong_to_alliacne));
                }
                return response.data;
            });
    }
    login_otp(user) {
        return axios
            .post('Check-user-with-sms', {
                email: user.email,
                password: user.password
            })
            .then(response => {
                // console.log(response.data)
                return response;
            });
    }
    logout() {
        // console.log('logout service')
        return axios.post('auth/logout')
            .then(resp => {
                localStorage.removeItem('accessToken')
                localStorage.removeItem('user')
                localStorage.removeItem('type')
                // localStorage.removeItem('consultant')
                // localStorage.removeItem('is_alliance_leader')
                // localStorage.removeItem('is_belong_to_alliacne')
                localStorage.removeItem('baseUrl')
                localStorage.removeItem('name_systemt')
                localStorage.removeItem('type_system')


                return resp
            })
            .catch(err => {
                localStorage.removeItem('accessToken')
                localStorage.removeItem('user')
                localStorage.removeItem('type')
                // localStorage.removeItem('consultant')
                // localStorage.removeItem('is_alliance_leader')
                // localStorage.removeItem('is_belong_to_alliacne')
                localStorage.removeItem('baseUrl')
                localStorage.removeItem('name_systemt')
                localStorage.removeItem('type_system')

                return err
            })
    }
    register(user) {
        // console.log(user)
        return axios.post('auth/register', user);
    }
    permission() {
        return axios.get('auth/permission-me');
    }
    reset_password(email) {
        return axios.post('auth/password-reset-request', email)
    }
    new_password(data) {
        return axios.post('auth/password-reset', data)
    }
}
export default new AuthService();